import { NextRouter, useRouter } from 'next/router';
import PageMeta from 'components/layout/PageMeta';
import LayoutConfines from 'components/layout/LayoutConfines';
import { BecomeSpeaker } from 'components/become-speaker/BecomeSpeaker';
import { getMetaInfo } from 'utils/helpers';

const BecomeSpeakerPage = () => {
  const { pathname }: NextRouter = useRouter();

  return (
    <>
      <PageMeta {...getMetaInfo(pathname)} />
      <LayoutConfines>
        <BecomeSpeaker />
      </LayoutConfines>
    </>
  );
};

export default BecomeSpeakerPage;
